module.exports = __webpack_public_path__ + "img/sushi.cfd02b50.svg";